export const PRIMARY = 'PRIMARY';
export const SECONDARY = 'SECONDARY';
export const TERTIARY = 'TERTIARY';
export const SUCCESS = 'SUCCESS';
export const DANGER = 'DANGER';
